module.exports = __webpack_public_path__ + "img/finish_later.15f9d301.svg";